import React from "react";
import { connect } from "react-redux";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Outlet } from "react-router-dom";

class BaseLayout extends React.Component {
  render() {
    return <div className="wrapper">
      {process.env.REACT_APP_SHOWBANNER === "true" && <div className="important-banner non-printable">
        <b>Important:</b>
        This website is currently in development and is not representative of
        the final version of the knowledge bank.
        <br />
        All information shown is for demonstration purposes only and should
        not be used to make decisions about using medicines during pregnancy
        or breastfeeding.
      </div>}
      <div className="content">
        <Header headerWithShadow={this.props.headerWithShadow} />
        <Outlet />
      </div>
      <Footer />
    </div>
  }
}

export default connect()(BaseLayout);
